import React from 'react';
import { DollarSign, Calculator, Package, Phone, Mail } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Helmet } from 'react-helmet-async';

const ShippingCostGuidePage = () => {
  return (
    <>
      <Helmet>
        <title>How Much Does Shipping to India from Canada Cost? | Price Guide – Shippzy</title>
        <meta name="description" content="Complete guide to Canada-India shipping costs. Understand pricing factors, weight calculations, carrier rates, and how to get the best shipping prices." />
        <link rel="canonical" href="https://www.shippzy.ca/shipping-cost-guide-canada-to-india" />
      </Helmet>
      <div className="min-h-screen bg-white">
        <section className="bg-gradient-to-br from-gray-900 via-gray-800 to-black text-white py-20">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="max-w-4xl">
              <h1 className="text-5xl md:text-6xl font-bold mb-6">Canada to India Shipping Cost Guide</h1>
              <p className="text-xl text-gray-300 mb-8">Comprehensive guide to understanding shipping costs from Canada to India. Learn about pricing factors, weight calculations, and how to get the best rates.</p>
            </div>
          </div>
        </section>
        <section className="py-20 bg-gray-50">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-3xl font-bold text-gray-900 mb-6">Factors That Affect Shipping Costs</h2>
            <div className="space-y-6">
              <Card><CardContent className="pt-6"><h3 className="font-semibold text-gray-900 mb-2">1. Weight & Dimensions</h3><p className="text-gray-600">Shipping costs are calculated based on actual weight or dimensional weight, whichever is greater. Dimensional weight = (Length × Width × Height in cm) ÷ 5000.</p></CardContent></Card>
              <Card><CardContent className="pt-6"><h3 className="font-semibold text-gray-900 mb-2">2. Destination in India</h3><p className="text-gray-600">Major cities like Delhi, Mumbai, Bangalore typically cost less than remote areas. Delivery time and pricing vary by location.</p></CardContent></Card>
              <Card><CardContent className="pt-6"><h3 className="font-semibold text-gray-900 mb-2">3. Carrier Selection</h3><p className="text-gray-600">DHL, FedEx, and UPS have different rate structures. We compare all carriers to find you the best price.</p></CardContent></Card>
              <Card><CardContent className="pt-6"><h3 className="font-semibold text-gray-900 mb-2">4. Service Speed</h3><p className="text-gray-600">Express services (3-7 days) cost more than economy options (15-25 days). Choose based on your timeline and budget.</p></CardContent></Card>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default ShippingCostGuidePage;